import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import Lottie from "react-lottie";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import constants from "src/constants";
import * as lottieAnywhere from "src/icons/Lottie-anywhere.json";
import * as lottieCommunity from "src/icons/Lottie-community.json";
import * as lottieYoga from "src/icons/Lottie-yoga.json";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sPlatformCard } from "src/styles/sPlatformCard.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
};

function PlatformCardsMembers({ style, className }: Props) {
  return (
    <div
      className={composeClassNames([
        sPlatformCard,
        className,
        "platform-cards",
      ])}
      style={style}
    >
      <div className="platform-card">
        <div className="platform-card-lottie">
          <Lottie
            options={{
              ...constants.Images.lottieDefaultOptions,
              animationData: lottieYoga,
            }}
            width={300}
            height={240}
          />
        </div>
        <div className="platform-card-text">
          <Heading
            type="h3"
            title={<Translate tKey={`Lessons, lectures, festivals`} />}
            className={composeClassNames([sGroupTitle, "platform-card-title"])}
          />
          <p>
            <Translate
              tKey={`Individual lessons with different topics, complete programs and complete courses, online and offline festivals.`}
            />
          </p>
        </div>
      </div>
      <div className="platform-card">
        <div className="platform-card-lottie">
          <Lottie
            options={{
              ...constants.Images.lottieDefaultOptions,
              animationData: lottieAnywhere,
            }}
            width={300}
            height={240}
          />
        </div>
        <div className="platform-card-text">
          <Heading
            type="h3"
            title={<Translate tKey={`Anytime and anywhere`} />}
            className={composeClassNames([sGroupTitle, "platform-card-title"])}
          />
          <p>
            <Translate
              tKey={`At home or at work, morning or evening. All you need is a phone or computer and an internet connection.`}
            />
          </p>
        </div>
      </div>
      <div className="platform-card">
        <div className="platform-card-lottie">
          <Lottie
            options={{
              ...constants.Images.lottieDefaultOptions,
              animationData: lottieCommunity,
            }}
            width={300}
            height={240}
          />
        </div>
        <div className="platform-card-text">
          <Heading
            type="h3"
            title={<Translate tKey={`The power of community`} />}
            className={composeClassNames([sGroupTitle, "platform-card-title"])}
          />
          <p>
            <Translate
              tKey={`The possibility of sharing progress with others, support of the VIVIDO team when choosing courses, individual lessons with popular instructors.`}
            />
          </p>
        </div>
      </div>
    </div>
  );
}

export default PlatformCardsMembers;
